module.exports = __webpack_public_path__ + "img/search-empty.95d1b562.png";